if (process.env.NODE_ENV === 'development') {
  module.exports = require('./stores.dev') // eslint-disable-line global-require
} else {
  module.exports = require('./stores.prod') // eslint-disable-line global-require
}
